export var SUPPORTED_LANGUAGES = ['en', 'ar', 'ru', 'fr', 'de'];
export var DEFAULT_LANGUAGE = 'en';
export var RoutesList;
(function (RoutesList) {
    RoutesList["Main"] = "";
    RoutesList["WhySahlTaxVsAgencies"] = "sahl_tax_vs_accounting_agencies";
    RoutesList["PricingPlans"] = "pricing_plans";
    RoutesList["Integrations"] = "integrations";
    RoutesList["TermsOfService"] = "terms_of_service";
    RoutesList["FAQ"] = "faq";
    RoutesList["FAQTaxableIncome"] = "faq/taxable_income";
    RoutesList["FAQReliefGuide"] = "faq/relief_guide";
    RoutesList["FAQBankStatementProcessing"] = "faq/bank_statement_processing";
    RoutesList["FAQTaxImplications"] = "faq/tax_implications";
    RoutesList["FAQBestSoftware"] = "faq/best_accounting_software_uae";
    RoutesList["FAQReferal"] = "faq/referal";
    RoutesList["PrivacyAndSecurity"] = "privacy_and_security";
    RoutesList["CancellationPolicy"] = "cancellation_policy";
    RoutesList["CookiesPolicy"] = "cookies_policy";
    RoutesList["WhySahlTax"] = "sahl_tax_is_the_best_for_UAE";
})(RoutesList || (RoutesList = {}));
export var buildPath = function (lang, route) {
    return route === RoutesList.Main ? "/".concat(lang) : "/".concat(lang, "/").concat(route);
};
